export enum WorkerDataChangeStatus {
    NOT_VERIFIED = 'NOT_VERIFIED',
    VERIFIED_AUTOMATICALLY = 'VERIFIED_AUTOMATICALLY',
    VERIFIED = 'VERIFIED',
    REJECTED = 'REJECTED'
}